import {Tag} from "antd";
import {
  StyledServiceOrderCard,
  StyledServiceOrderCardBody,
  StyledServiceOrderCardBodyContent,
  StyledServiceOrderCardBodyContentDetails,
  StyledServiceOrderCardBodyContentDetailsItem,
  StyledServiceOrderCardBodyContentHeader,
  StyledServiceOrderCardBodyContentHeaderDetails,
  StyledServiceOrderCardBodyContentHeaderOrderTime,
  StyledServiceOrderCardContentButtonWrapper,
  StyledServiceOrderCardSideCap,
} from "../../card/styles";
import {GetStoreServicesOrdersApiResponse} from "../../../../../../react-query-hooks/store/services/get-orders/types";
import moment from "moment";
import {mapStatusIdToStatus} from "../../list/list";
import {orderStatusTagColors, orderStatusTags} from "../../card";

export type CustomerServiceOrderCardProps = {
  order: GetStoreServicesOrdersApiResponse["orders"][0];
  onShowDetails: () => void;
};

export function CustomerServiceOrderCard({
  onShowDetails,
  order,
}: CustomerServiceOrderCardProps) {
  // v2 returns the coach's display name; `firstName`/`lastName` on the order are
  // the customer's own, so they are only a last-resort fallback here.
  const coachName =
    order.coachDisplayName?.trim() || `${order.firstName} ${order.lastName}`.trim();
  const deliveryDate = moment(order.delivery_date).format("MMMM DD, YYYY");
  const startDate = moment(order.createdAt).format("MMMM DD, YYYY");
  const orderTime = `Ordered ${moment(order.createdAt).fromNow()}`;
  const price = +order.amount > 0 ? `${order.currency} ${order.amount}` : "Free";
  const projectName = order.productService.name;
  const status = mapStatusIdToStatus(order.statusId);
  const orderStatus = orderStatusTags[status];

  return (
    <>
      <StyledServiceOrderCard>
        <StyledServiceOrderCardContentButtonWrapper onClick={onShowDetails} />
        <StyledServiceOrderCardSideCap $status={status} />
        <StyledServiceOrderCardBody>
          <StyledServiceOrderCardBodyContent>
            <StyledServiceOrderCardBodyContentHeader>
              <StyledServiceOrderCardBodyContentHeaderOrderTime>
                {orderTime}
              </StyledServiceOrderCardBodyContentHeaderOrderTime>
              <StyledServiceOrderCardBodyContentHeaderDetails>
                <p className="project-name">{projectName}</p>
                <Tag color={orderStatusTagColors[status]} title="In progress">
                  {orderStatus}
                </Tag>
              </StyledServiceOrderCardBodyContentHeaderDetails>
            </StyledServiceOrderCardBodyContentHeader>
            <StyledServiceOrderCardBodyContentDetails>
              <StyledServiceOrderCardBodyContentDetailsItem>
                <p>
                  Coach: <span className="item-value">{coachName}</span>
                </p>
              </StyledServiceOrderCardBodyContentDetailsItem>
              <StyledServiceOrderCardBodyContentDetailsItem>
                <p>
                  Price: <span className="item-value">{price}</span>
                </p>
              </StyledServiceOrderCardBodyContentDetailsItem>
              <StyledServiceOrderCardBodyContentDetailsItem>
                {status === "completed" ? (
                  <p>
                    Order timeline:{" "}
                    <span className="item-value">{`${startDate} - ${deliveryDate}`}</span>
                  </p>
                ) : (
                  <p>
                    Est. delivery date: <span className="item-value">{deliveryDate}</span>
                  </p>
                )}
              </StyledServiceOrderCardBodyContentDetailsItem>
            </StyledServiceOrderCardBodyContentDetails>
          </StyledServiceOrderCardBodyContent>
        </StyledServiceOrderCardBody>
      </StyledServiceOrderCard>
    </>
  );
}
